import { StyledComponent } from '@emotion/styled'
import Button from 'components/Common/Button'
import InputField, { InputFieldProps } from 'components/Form/InputField'
import tw, { styled } from 'twin.macro'

import { FormProps } from './validator'

export const Form = styled.form([tw`w-full flex flex-wrap`])

export const EmailField = styled(InputField)([
  tw`w-full mt-4`,
]) as StyledComponent<InputFieldProps<FormProps>>

export const Description = styled.article([tw`mt-4 text-xs`])

export const SubmitButton = styled(Button)([tw`w-full mt-8`])

export const BackButton = styled(Button)()

EmailField.defaultProps = {
  type: 'email',
}

SubmitButton.defaultProps = {
  type: 'submit',
  variant: 'secondary',
}

BackButton.defaultProps = {
  type: 'button',
  variant: 'link',
}
